/* eslint-disable no-underscore-dangle */
import { Model } from 'backbone';
import EventEmitter from './eventEmitter';
import namespace from './namespace';

/**
 * OFCS base object
 *
 * Gives extend and events to all objects
 *
 * @class Ofcs.Object
 * @extends Backbone.Events
 */
export default class OfcsObject extends EventEmitter {
    /**
     * Create new object instance
     *
     * @constructor
     */
    constructor(...args) {
        super(...args);
        this.initialize(...args);
    }

    initialize() {}
}

/**
 * @deprecated
 * @param {...*} args
 * @return {*}
 */
OfcsObject.extend = function extend(...args) {
    const child = Model.extend.apply(this, args);
    const parent = {};
    child.prototype.__parent = parent;
    const prototype = child.__super__;

    Object
        .keys(prototype)
        .filter(key => !!prototype[key])
        .forEach(key => (parent[key] = prototype[key]));

    return child;
};

namespace('Ofcs.Object');
window.Ofcs.Object = OfcsObject;
